/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { CreatableSelectV2, DatePickerV2, DialogDefaultV2, InputV2 } from '../../../components/v2';
import BaseService from 'services/BaseService';

const mapTransportadoraOptions = (payload) => {
  const list = Array.isArray(payload) ? payload : [];
  return list
    .map((item) => {
      const label = typeof item === 'string' ? item.trim() : '';
      if (!label) return null;
      return { value: label, label };
    })
    .filter(Boolean);
};

const isDateValid = (value) => {
  if (value === null || value === undefined || value === '') return false;
  return moment(value).isValid();
};

const DespacharDialog = ({ open, onClose, onConfirm, entrega, submitting }) => {
  const [codigoRastreamento, setCodigo] = useState('');
  const [possuiCodigoRastreamento, setPossuiCodigo] = useState(false);
  const [transportadoraOption, setTransportadoraOption] = useState(null);
  const [transportadoraOptions, setTransportadoraOptions] = useState([]);
  const [dataEsperadaEntrega, setDataEsperada] = useState(null);
  const [error, setError] = useState(false);
  const pedeTransportadora = !entrega
    || !entrega.tipoEntrega
    || entrega.tipoEntrega === 'TRANSPORTADORA';

  useEffect(() => {
    if (!open) return;
    const codigoSalvo = String((entrega && entrega.codigoRastreamento) || '').trim();
    const nome = String((entrega && entrega.transportadora) || '').trim();
    const temCodigo = Boolean(
      (entrega && entrega.possuiCodigoRastreamento) || codigoSalvo
    );
    setPossuiCodigo(temCodigo);
    setCodigo(codigoSalvo);
    setTransportadoraOption(nome ? { value: nome, label: nome } : null);
    setDataEsperada(
      entrega && entrega.dataEsperadaEntrega
        ? moment(entrega.dataEsperadaEntrega).valueOf()
        : null
    );
    setError(false);
    const loadTransportadoras = async () => {
      try {
        const response = await BaseService.get({ url: 'entregas/transportadoras' });
        setTransportadoraOptions(mapTransportadoraOptions(response?.data));
      } catch (e) {
        setTransportadoraOptions([]);
      }
    };
    loadTransportadoras();
  }, [open, entrega]);

  useEffect(() => {
    if (!open || !entrega) return;
    const nome = String(entrega.transportadora || '').trim();
    if (!nome) return;
    const found = transportadoraOptions.find((option) => option.label === nome);
    if (!found) return;
    setTransportadoraOption((current) => {
      if (!current || current.label !== nome) return current;
      return found;
    });
  }, [open, entrega, transportadoraOptions]);

  const transportadoraNome = (transportadoraOption && transportadoraOption.label
    ? transportadoraOption.label
    : ''
  ).trim();
  const opcoesTransportadora = (() => {
    if (!transportadoraNome || (transportadoraOption && transportadoraOption.__isNew__)) {
      return transportadoraOptions;
    }
    if (transportadoraOptions.some((option) => option.label === transportadoraNome)) {
      return transportadoraOptions;
    }
    return [{ value: transportadoraNome, label: transportadoraNome }, ...transportadoraOptions];
  })();

  const handleConfirm = () => {
    if (submitting) return;
    const codigoFinal = possuiCodigoRastreamento ? codigoRastreamento.trim() : '';
    if ((pedeTransportadora && !transportadoraNome) || !isDateValid(dataEsperadaEntrega) || (possuiCodigoRastreamento && !codigoFinal)) {
      setError(true);
      return;
    }
    onConfirm({
      codigoRastreamento: codigoFinal || null,
      possuiCodigoRastreamento,
      transportadora: pedeTransportadora ? transportadoraNome : null,
      dataEsperadaEntrega: moment(dataEsperadaEntrega).format('YYYY-MM-DD'),
      observacao: null,
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Despachar entrega"
      confirmMessage="Despachar"
      confirmLoadingMessage="Despachando…"
      cancelMessage="Fechar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
      confirmLoading={submitting}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Confirmar o despacho? A entrega passa a em trânsito e os itens ficam enviados.
          </Typography>
        </Grid>
        {pedeTransportadora && (
          <Grid size={{ xs: 12 }}>
            <CreatableSelectV2
              label="Transportadora"
              isRequired
              error={error && !transportadoraNome}
              options={opcoesTransportadora}
              value={transportadoraOption}
              onChange={(option) => {
                setTransportadoraOption(option);
                setError(false);
              }}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12 }}>
          <DatePickerV2
            label="Data esperada de entrega"
            value={dataEsperadaEntrega}
            isRequired
            error={error && !isDateValid(dataEsperadaEntrega)}
            onChange={(value) => {
              setDataEsperada(value);
              setError(false);
            }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <FormControlLabel
            control={(
              <Checkbox
                checked={possuiCodigoRastreamento}
                onChange={(event) => {
                  const checked = event.target.checked;
                  setPossuiCodigo(checked);
                  if (!checked) setCodigo('');
                  setError(false);
                }}
              />
            )}
            label="Possui código de rastreamento?"
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Código de rastreamento"
            value={codigoRastreamento}
            onChange={(e) => {
              setCodigo(e.target.value);
              setError(false);
            }}
            isRequired={possuiCodigoRastreamento}
            error={error && possuiCodigoRastreamento && !codigoRastreamento.trim()}
            disabled={!possuiCodigoRastreamento}
            inputProps={{ readOnly: !possuiCodigoRastreamento }}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

DespacharDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  entrega: PropTypes.object,
  submitting: PropTypes.bool,
};

DespacharDialog.defaultProps = {
  entrega: null,
  submitting: false,
};

export default DespacharDialog;
